<template>
  <div>
    <ul>
      <li @click="toItem('days7')" :class="[{'btn-primary2':current==='days7'}]">近7天</li>
      <li @click="toItem('days30')" :class="[{'btn-primary2':current==='days30'}]">近30天</li>
      <li @click="toItem('byweek')" :class="[{'btn-primary2':current==='byweek'}]">按周</li>
      <li @click="toItem('bymonth')" :class="[{'btn-primary2':current==='bymonth'}]">按月</li>
      <li @click="toItem('byself')" :class="[{'btn-primary2':current==='byself'}]">自定义</li>
    </ul>
    <!--:show-week-numbers="current==='byweek'"-->

    <!--:disabled="current==='days7' || current ==='days30'"-->
    <DatePicker type="daterange"
                placeholder=""
                style="width: 240px;"
                v-model="date"
                @on-change="changeType"

                :options="dateOption"

                :clearable="false"
                v-show="current!=='bymonth' && current!=='byweek'"
                split-panels
                :key="'others'"
    ></DatePicker>


    <DatePicker type="daterange"
                v-if="current==='byweek'"
                show-week-numbers
                :options="dateOption"
                :key="'week'"
                @on-change="chooseDate"
                v-model="dateWeek"
                :clearable="false"
                style="width: 240px;"

                split-panels


    ></DatePicker>
    <DatePicker
      :key="'month'"
      v-if="current==='bymonth'"
      v-model="monthDate"

      type="month" placeholder=" "
      style="width: 240px" :options="dateOption2"

    ></DatePicker>

    <!--<DatePicker type="daterange" v-model="testData" style="width: 200px;"  split-panels placeholder="111" :key="'hhhh'"></DatePicker>-->

  </div>
</template>

<script>
  import {formatDateTime} from "../../../utils/format";

  export default {
    name: "DatePublic",
    data() {
      return {
        // testData:['2018-12-31','2019-01-06'],
        dateWeek: ['', ''],
        monthDate: '',
        current: 'days7',
        date: ['', ''],
        year: '',  //年
        month: '',  //月
        day: '',  //日
        weekIndex: '',  //星期索引
        onedaysecond: 86400000,
        dateOption: {
          disabledDate(date) {
            return date && date.valueOf() > Date.now();
          }
        },
        dateOption2: {
          disabledDate(date) {
            let date1 = new Date()
            let year = date1.getFullYear()
            let month = date1.getMonth()
            // this.day = date1.getDate()
            // this.weekIndex = date1.getDay()
            return date && date.valueOf() > (new Date(year, month, 1)).valueOf() - 86400000;
          }

        },
        timer: null
      }
    },
    computed: {
      dataToSend() {
        let ret = {}
        if (this.current === 'bymonth') {
          ret['startTime'] = formatDateTime(this.monthDate, false)
          let year = this.monthDate.getFullYear()
          let month = this.monthDate.getMonth()

          ret['endTime'] = formatDateTime(new Date(year, month + 1, 0), false)

        }
        else if (this.current === 'byweek') {
          ret['startTime'] = formatDateTime(this.dateWeek[0], false)
          ret['endTime'] = formatDateTime(this.dateWeek[1], false)

        }
        else {
          ret['startTime'] = formatDateTime(this.date[0], false)
          ret['endTime'] = formatDateTime(this.date[1], false)
        }

        let map = {
          'days7': 0,
          'days30': 0,
          'byself': 0,
          'byweek': 1,
          'bymonth': 2
        }
        ret['type'] = map[this.current]
        return ret
      }
    },

    methods: {
      changeType(){
        this.current='byself'
      },
      chooseDate(value) {
        let date1 = new Date(value[0])
        let date2 = new Date(value[1])

        let year2 = date2.getFullYear()
        let month2 = date2.getMonth()
        let day2 = date2.getDate()
        let weekIndex2 = date2.getDay()


        let year1 = date1.getFullYear()
        let month1 = date1.getMonth()
        let day1 = date1.getDate()
        let weekIndex1 = date1.getDay()


        //按周处理
        if (this.current === 'byweek') {
          let date2ToSunday, date1ToMonday
          if (weekIndex2 === 0) {
            date2ToSunday = new Date(year2, month2, day2)
          }
          else {
            date2ToSunday = new Date(year2, month2, day2 + (7 - weekIndex2))
          }

          if (weekIndex1 === 0) {
            date1ToMonday = new Date(year1, month1, day1 - 6)
          }
          else {
            date1ToMonday = new Date(year1, month1, day1 - weekIndex1 + 1)
          }

          //超出可选区域
          if (date2ToSunday.valueOf() > (new Date(this.year, this.month, this.day)).valueOf()) {
            date2ToSunday = new Date(year2, month2, date2ToSunday.getDate() - 7)
          }
          //
          if (date1ToMonday.valueOf() > date2ToSunday.valueOf()) {
            date1ToMonday = new Date(year1, month1, date1ToMonday.getDate() - 7)
          }
          this.dateWeek = [formatDateTime(date1ToMonday, false), formatDateTime(date2ToSunday, false)]
        }


      },
      toItem(current) {
        this.$emit('clickItem', current)
        this.current = current
        if (current === 'days7') {
          this.getRecent(7)
        }
        if (current === 'days30') {
          this.getRecent(30)
        }
        if (current === 'byweek') {
          this.setLastWeek()
        }
        if (current === 'bymonth') {
          this.setLastMonth()
        }
      },
      setLastMonth() {
        this.monthDate = formatDateTime(new Date(this.year, this.month - 1, 1), false)
      },
      setLastWeek() {   //上周一 到 周日

        if (this.weekIndex === 0) {
          this.dateWeek = [formatDateTime(new Date(this.year, this.month, this.day - 14), false),
            formatDateTime(new Date(this.year, this.month, this.day - 8), false)]
        }
        else {
          this.dateWeek = [formatDateTime(new Date(this.year, this.month, this.day - (this.weekIndex + 6)), false),
            formatDateTime(new Date(this.year, this.month, this.day - (this.weekIndex)), false)]
        }

      },
      getRecent(value) {
        this.date = [formatDateTime(new Date(this.year, this.month, this.day - value + 1), false),
          formatDateTime(new Date(this.year, this.month, this.day), false)]
      },
      initData() {
        let date = new Date()
        this.year = date.getFullYear()
        this.month = date.getMonth()
        this.day = date.getDate()
        this.weekIndex = date.getDay()
      },
    },
    created() {
      this.initData()
      this.getRecent(7)
    }
  }
</script>
<style scoped>
  ul, li {
    display: inline-block;
  }

  ul li {
    cursor: grab;
    margin-right: 10px;
  }


</style>
